// extracted by mini-css-extract-plugin
export default {"container":"NewsCommentForm_container__iOiXC"};